/**
 * Per-profile wording for the red «booking time ended» box on the profile (BulkService).
 * Owner request 2026-11-04: Dr. Davood Shafiei only — every other profile keeps the default text.
 */
const CLOSED_TEXT_OVERRIDES: Record<string, string> = {
  'دکتر-داود-شفیعی-2': 'زمان نوبت دهی در بیمارستان فوق تخصصی قلب شهید دکتر چمران به پایان رسیده است.',
};

export const getClosedTextOverride = (slug?: string | null): string | undefined =>
  slug ? CLOSED_TEXT_OVERRIDES[slug] : undefined;
